export const IconGlobe = (props: IconClip) => {
	return (
		<svg
			width={props.width ?? 16}
			height={props.height ?? 16}
			viewBox="0 0 24 24"
			fill="none"
			stroke={props.color ?? "#d9dfe9"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<circle cx="12" cy="12" r="10" />
			<path d="M2 12h20" />
			<path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
		</svg>
	);
};
